import { createContext, FC, useContext } from 'react';

type TCurrencyContext = {
    currencyIso: string;
};

const CurrencyContext = createContext<TCurrencyContext>({ currencyIso: 'EUR' });

export const CurrencyContextProvider: FC<TCurrencyContext> = ({ currencyIso, children }) => {
    return <CurrencyContext.Provider value={{ currencyIso }}>{children}</CurrencyContext.Provider>;
};

export function useCurrencyContext() {
    return useContext(CurrencyContext);
}
